import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import { standardFocusStyleDeclarations } from '@nib-components/theme';
import { paddings, p } from '@nib/layout';
// eslint-disable-next-line  @typescript-eslint/no-unused-vars
export const UnstyledButton = styled(_ref => {
  let {
    padding,
    paddingVertical,
    paddingHorizontal,
    paddingTop,
    paddingBottom,
    paddingLeft,
    paddingRight,
    ...rest
  } = _ref;
  return /*#__PURE__*/_jsx("button", {
    ...rest
  });
})`
  appearance: none;
  background: none;
  border: none;
  ${p(0)};
  cursor: pointer;
  line-height: 1;
  color: currentColor;

  &:focus-visible {
    ${standardFocusStyleDeclarations};
  }
  ${paddings()};
`;
export default UnstyledButton;
UnstyledButton.displayName = 'UnstyledButton';